"use strict";

require("core-js/modules/es.string.split");

var curry = require("./curry.js");

var isArray = require("./isArray.js");

var reduce = require("./reduce.js");

var findWhere = require("./findWhere.js");

module.exports = sep => curry(function sel(selector, acc) {
  return !selector ? acc : isArray(selector) ? reduce((acc, selector) => sel(selector, acc), acc, selector) : typeof selector == 'object' || typeof selector == 'function' ? findWhere(selector, acc) : reduce((acc, key, s = key[0]) => !acc ? undefined : s == '#' ? findWhere({
    id: key.substr(1)
  }, acc) : s == '[' || s == '{' ? findWhere(JSON.parse(key), acc) : acc[key], acc, selector.split(sep));
});